/* eslint-disable */
import React from 'react';
import { Field, FieldArray, ErrorMessage } from 'formik';
import {
    Box,
    Grid,
    TextField,
    MenuItem,
    Button,
    FormControl,
    Chip,
    Select,
    FormHelperText,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Typography,
    Collapse,
    IconButton,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormLabel,
    Autocomplete
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { gridSpacing, roles } from 'store/constant';

import HelpIcon from './HelpIcon';
import { tips } from './HelpData';
import { ExpandLess, ExpandMore, Delete } from '@mui/icons-material';
import { roomFeatures, roomLevel, roomType } from './data/rooms_data';
import ImageUploadComponent from '../Management/Details/PhotosData';
import GreenEnergy from './GreenEnergy';

const RoomsInfo = ({
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    isSubmitting,
    values,
    touched,
    setFieldValue,
    dispatch,
    deleteRoomListings,
    isDuplicate,
    id,
    openSnackbar,
    singleListing,
    role,
    deleteGreenEnergyBuildingListings
}) => {
    const [openOptional, setOpenOptional] = React.useState(true);

    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };

    return (
        <Grid item xs={12}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                                mb: 2
                            }}
                        >
                            Photos
                        </Typography>

                        <SubCard>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    {id && isDuplicate !== 'YES' && (
                                        <ImageUploadComponent propertyId={id} data={singleListing?.attachments} />
                                    )}
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer',
                                mb: 2,
                                p: 1,
                                background: 'white'
                            }}
                            onClick={handleToggle}
                        >
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    textTransform: 'capitalize'
                                }}
                            >
                                Optional Information
                            </Typography>
                            <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                        </Box>

                        <Collapse in={openOptional}>
                            {role === roles.ADMIN && (
                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            m: 3
                                        }}
                                    >
                                        Rooms Accommodations
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <FieldArray name="rooms">
                                                {({ push, remove }) => (
                                                    <Grid container spacing={2} sx={{ m: '16px', p: '16px' }}>
                                                        {values?.rooms?.map((_, index) => (
                                                            <Box
                                                                sx={{
                                                                    borderBottom: '1px solid #9f9f9f',
                                                                    width: '100%',
                                                                    p: 2,
                                                                    mb: 2
                                                                }}
                                                                key={index}
                                                            >
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} sm={5}>
                                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'baseline' }}>
                                                                            <FormLabel
                                                                                sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                                            >
                                                                                <Typography
                                                                                    variant="subtitle1"
                                                                                    fontWeight="bold"
                                                                                    component="span"
                                                                                >
                                                                                    Room Type
                                                                                </Typography>
                                                                            </FormLabel>
                                                                            <HelpIcon
                                                                                title={tips.roomType.title}
                                                                                ruleHelp={tips.roomType.ruleHelp}
                                                                                generalHelpDesc={tips.roomType.generalHelpDesc}
                                                                            />
                                                                        </Box>
                                                                        <Field
                                                                            name={`rooms[${index}].roomType`}
                                                                            as={TextField}
                                                                            fullWidth
                                                                            select
                                                                            variant="outlined"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            helperText={<ErrorMessage name={`rooms[${index}].roomType`} />}
                                                                            error={
                                                                                touched.rooms?.[index]?.roomType &&
                                                                                Boolean(errors.rooms?.[index]?.roomType)
                                                                            }
                                                                        >
                                                                            {roomType.map((option) => (
                                                                                <MenuItem key={option} value={option}>
                                                                                    <ListItemText primary={option} />
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Field>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={5}>
                                                                        <FormControl fullWidth>
                                                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'baseline' }}>
                                                                                <FormLabel
                                                                                    sx={{
                                                                                        '& .MuiFormLabel-asterisk': { color: 'red' }
                                                                                    }}
                                                                                >
                                                                                    <Typography
                                                                                        variant="subtitle1"
                                                                                        fontWeight="bold"
                                                                                        component="span"
                                                                                    >
                                                                                        Room Features
                                                                                    </Typography>
                                                                                </FormLabel>
                                                                                <HelpIcon
                                                                                    title={tips.roomFeatures.title}
                                                                                    ruleHelp={tips.roomFeatures.ruleHelp}
                                                                                    generalHelpDesc={tips.roomFeatures.generalHelpDesc}
                                                                                />
                                                                            </Box>

                                                                            <Autocomplete
                                                                                renderTags={(tagValue, getTagProps) =>
                                                                                    tagValue.map((option, index) => (
                                                                                        <Chip
                                                                                            key={index}
                                                                                            label={option}
                                                                                            {...getTagProps({ index })}
                                                                                            sx={{
                                                                                                '& .MuiChip-deleteIcon': {
                                                                                                    color: 'black !important'
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                                multiple
                                                                                disableCloseOnSelect
                                                                                options={roomFeatures}
                                                                                value={values.rooms[index]?.roomFeatures || []}
                                                                                onChange={(event, newValue) => {
                                                                                    setFieldValue(
                                                                                        `rooms[${index}].roomFeatures`,
                                                                                        newValue || []
                                                                                    );
                                                                                }}
                                                                                onBlur={handleBlur}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        variant="outlined"
                                                                                        label="Room Features"
                                                                                        fullWidth
                                                                                    />
                                                                                )}
                                                                                renderOption={(props, option, { selected }) => (
                                                                                    <li {...props}>
                                                                                        <Checkbox checked={selected} sx={{ mr: 1 }} />
                                                                                        <ListItemText primary={option} />
                                                                                    </li>
                                                                                )}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={1} />

                                                                    <Grid item xs={12} sm={1}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                if (values.rooms.length > 1) {
                                                                                    remove(index);
                                                                                    if (id !== 'add' && !isDuplicate) {
                                                                                        if (values.rooms[index]?.id) {
                                                                                            dispatch(
                                                                                                deleteRoomListings(values.rooms[index]?.id)
                                                                                            );
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                            variant="contained"
                                                                            sx={{
                                                                                border: '1px solid red',
                                                                                background: 'white',
                                                                                color: 'red',
                                                                                display: 'flex',
                                                                                justifyContent: 'center', // Center content horizontally
                                                                                alignItems: 'center' // Center content vertically
                                                                            }}
                                                                        >
                                                                            <Delete />
                                                                        </Button>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                            <FormLabel
                                                                                sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                                            >
                                                                                <Typography
                                                                                    variant="subtitle1"
                                                                                    fontWeight="bold"
                                                                                    component="span"
                                                                                >
                                                                                    Room Level
                                                                                </Typography>
                                                                            </FormLabel>
                                                                            <HelpIcon
                                                                                title={tips.roomLevel.title}
                                                                                ruleHelp={tips.roomLevel.ruleHelp}
                                                                                generalHelpDesc={tips.roomLevel.generalHelpDesc}
                                                                            />
                                                                        </Box>
                                                                        <Field name={`rooms[${index}].roomLevel`}>
                                                                            {({ field }) => (
                                                                                <RadioGroup
                                                                                    row
                                                                                    {...field}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                >
                                                                                    {roomLevel.map((option) => (
                                                                                        <FormControlLabel
                                                                                            key={option}
                                                                                            value={option}
                                                                                            control={<Radio />}
                                                                                            label={option}
                                                                                            sx={{
                                                                                                marginLeft: '6px',
                                                                                                marginBottom: '12px',
                                                                                                border: '1px solid #ccc',
                                                                                                borderRadius: '5px',
                                                                                                padding: '2px 14px',
                                                                                                minWidth: '180px'
                                                                                            }}
                                                                                        />
                                                                                    ))}
                                                                                </RadioGroup>
                                                                            )}
                                                                        </Field>
                                                                        {/* <Field
                                                                        name={`rooms[${index}].roomLevel`}
                                                                        as={TextField}
                                                                        fullWidth
                                                                        select
                                                                        variant="outlined"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        helperText={<ErrorMessage name={`rooms[${index}].roomLevel`} />}
                                                                        error={
                                                                            touched.rooms?.[index]?.roomLevel &&
                                                                            Boolean(errors.rooms?.[index]?.roomLevel)
                                                                        }
                                                                    >
                                                                        {roomLevel.map((option) => (
                                                                            <MenuItem key={option} value={option} sx={{ my: 0.5 }}>
                                                                                <ListItemText primary={option} />
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Field> */}
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={12}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                            <FormLabel
                                                                                sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}
                                                                            >
                                                                                <Typography
                                                                                    variant="subtitle1"
                                                                                    fontWeight="bold"
                                                                                    component="span"
                                                                                >
                                                                                    Room Description
                                                                                </Typography>
                                                                            </FormLabel>
                                                                            <HelpIcon
                                                                                title={tips.roomDescription.title}
                                                                                ruleHelp={tips.roomDescription.ruleHelp}
                                                                                generalHelpDesc={tips.roomDescription.generalHelpDesc}
                                                                            />
                                                                        </Box>
                                                                        <Field
                                                                            name={`rooms[${index}].roomDescription`}
                                                                            as={TextField}
                                                                            fullWidth
                                                                            multiline
                                                                            rows={4}
                                                                            variant="outlined"
                                                                            placeholder="Example: Our Deluxe Room offers a luxurious yet cozy atmosphere, featuring a plush king-sized bed, modern furnishings, and a spacious bathroom. Perfect for travelers seeking comfort and convenience, the room comes with complimentary Wi-Fi, a flat-screen TV, and a fully stocked minibar."
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        ))}
                                                        <Button
                                                            onClick={() => {
                                                                const val = values.rooms.length - 1; // get the last index
                                                                if (
                                                                    values.rooms[val].roomFeatures.length &&
                                                                    values.rooms[val].roomDescription &&
                                                                    values.rooms[val].roomLevel &&
                                                                    values.rooms[val].roomType
                                                                ) {
                                                                    push({
                                                                        roomType: '',
                                                                        roomLevel: '',
                                                                        roomFeatures: [],
                                                                        roomDescription: ''
                                                                    });
                                                                } else {
                                                                    dispatch(
                                                                        openSnackbar({
                                                                            open: true,
                                                                            message: `Please fill above details`,
                                                                            variant: 'alert',
                                                                            alert: {
                                                                                color: 'error'
                                                                            },
                                                                            close: true
                                                                        })
                                                                    );
                                                                }
                                                            }}
                                                            variant="contained"
                                                            sx={{ background: '#0a66c2', py: 1.25 }}
                                                        >
                                                            Add More Rooms
                                                        </Button>
                                                    </Grid>
                                                )}
                                            </FieldArray>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                            )}

                            <GreenEnergy
                                errors={errors}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                isSubmitting={isSubmitting}
                                values={values}
                                touched={touched}
                                setFieldValue={setFieldValue}
                                deleteGreenEnergyBuildingListings={deleteGreenEnergyBuildingListings}
                                dispatch={dispatch}
                                isDuplicate={isDuplicate}
                                id={id}
                                openSnackbar={openSnackbar}
                            />
                        </Collapse>
                    </Grid>
                </Grid>

                {errors.submit && (
                    <Grid item xs={12}>
                        <FormHelperText error>{errors.submit}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default RoomsInfo;
